module.exports = __webpack_public_path__ + "static/media/universal_socket_grip.900f20d5.jpg";